import React from 'react';

const Feedback = ({ feedback }) => {
  return (
    <div className='feedback'>
      <h4 className='feedback__title'>Phản hồi về doanh nghiệp</h4>
      <div className='feedback__list'>
        {feedback && feedback.length > 0
          ? feedback.map((item) => {
              return (
                <div className='item'>
                  <div className='header flex-lc'>
                    <div
                      className='avatar flex-center'
                      style={{ background: '#DC4646' }}
                    >
                      <span>L</span>
                    </div>
                    <div className='user'>
                      <h5>{item.user_name}</h5>
                    </div>
                  </div>
                  <div className='content'>
                    <p>{item.content}</p>
                  </div>
                </div>
              );
            })
          : 'Chưa có phản hồi nào.'}
      </div>
    </div>
  );
};

export default Feedback;
